export const ENQUIRY_STATUSES = [
  "New",
  "Contacted",
  "Consultation Booked",
  "Consultation Completed",
  "Converted to Treatment",
  "Lost / Did Not Convert",
];

export const TREATMENT_STATUSES = [
  "Not Started",
  "Started",
  "Completed",
  "Dropped Out",
];

export const CHART_COLORS = [
  "#059669", "#0891B2", "#7C3AED", "#DB2777", "#F59E0B",
  "#3B82F6", "#EF4444", "#14B8A6", "#F97316", "#8B5CF6", "#64748B",
];
